module.exports = __webpack_public_path__ + "static/media/own_delivery_reports.4345790e.svg";